import React from 'react'
import {
  DataGrid,
  useGridApiRef
} from '@mui/x-data-grid'
import { styled } from '@mui/material/styles'
import notFound from "../../../../containers/Contacts/Table/NotFoundData"
import { formatMoney } from "../../../../utils/amount";

// Local styled component removed in favor of global theme overrides

const ThirdStepTable = ({ data = [] }) => {

  const apiRef = useGridApiRef()

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      flex: 1
    },
    {
      "field": "programLength",
      "headerName": "Program Length",
      renderCell: (params) => {
        return (
          <div className="">{`${params?.row?.programLength || 0}`}</div>
        )
      },
      sortable: false,
      flex: 1
    },
    {
      "field": "programFee",
      "headerName": "Program Fee",
      renderCell: (params) => {
        return (
          <div className="">{`${params?.row?.programFee || 0}%`}</div>
        )
      },
      sortable: false,
      flex: 1
    },
    {
      "field": "custodialFee",
      "headerName": "Custodial Fee",
      sortable: false,
      flex: 1
    },

    {
      "field": "totalPayment",
      "headerName": "Total Payment",
      renderCell: (params) => {
        return (
          <div className="">{formatMoney(params?.row?.totalPayment) || 0}</div>
        )
      },
      sortable: false,
      flex: 1
    },
    {
      "field": "accountBalance",
      "headerName": "Account Balance",
      renderCell: (params) => {
        return (
          <div className="">{formatMoney(params?.row?.accountBalance) || 0}</div>
        )
      },
      sortable: false,
      flex: 1
    }
  ]

  return (
    <div>
      <DataGrid
        sx={{
          border: 'none',
          '& .MuiDataGrid-columnHeaders': {
            '.MuiButtonBase-root[aria-haspopup="menu"]': {
              display: 'none'
            }
          },
          '.MuiDataGrid-virtualScroller': {
            minHeight: data?.length === 0 ? 300 : ''
          }
        }}
        rowHeight={75}
        columns={columns}
        slots={{
          noRowsOverlay: notFound,
        }}
        columnVisibilityModel={{
          id: false
        }}
        rows={data}
        apiRef={apiRef}
        hideFooterPagination={true}
        disableRowSelectionOnClick
        disableColumnSelector
        getRowClassName={(params) => params?.row?.status === 'Failed' ? 'bg-error-200' : ''}
      />

    </div>
  )
}

export default ThirdStepTable
